module.exports = __webpack_public_path__ + "img/avatar5.6b6dfce0.jpg";